import { createTheme } from '@mui/material';
import type { DefaultTheme } from 'styled-components';

import type { StringObject } from './interfaces';

declare module '@mui/material/styles' {
  interface Palette {
    brand: {
      extraLightBlue: string;
      lightBlue: string;
      whiteBlue: string;
      midBlue: string;
      blue: string;
      borderBlue: string;
      darkBlue: string;
      blackPearl: string;
      blackPearl10: string;
      blackPearl30: string;
      extraLightGold: string;
      lightGold: string;
      gold: '#FFBF00';
      darkGold: string;
      extraLightPink: string;
      lightPink: string;
      pink: string;
      darkPink: string;
      extraLightGreen: string;
      lightGreen: string;
      green: string;
      darkGreen: string;
      emeraldGreen: string;
    };
  }

  interface PaletteOptions {
    brand?: {
      extraLightBlue: string;
      lightBlue: string;
      whiteBlue: string;
      midBlue: string;
      blue: string;
      borderBlue: string;
      darkBlue: string;
      blackPearl: string;
      blackPearl10: string;
      blackPearl30: string;
      extraLightGold: string;
      lightGold: string;
      gold: '#FFBF00';
      darkGold: string;
      extraLightPink: string;
      lightPink: string;
      pink: string;
      darkPink: string;
      extraLightGreen: string;
      lightGreen: string;
      green: string;
      darkGreen: string;
      emeraldGreen: string;
    };
  }
}

export interface StyledTheme {
  colors: StringObject;
  media: StringObject;
  sidebar: {
    zIndex: number;
  };
  transition: {
    duration: {
      short: number;
    };
    easing: {
      easeInOut: string;
    };
  };
}

export const mainTheme: DefaultTheme = {
  colors: {
    extraLightBlue: '#E5F7FF',
    lightBlue: '#ACD2E5',
    whiteBlue: '#E6F7FF',
    midBlue: '#8FAFBF',
    blue: '#335566',
    borderBlue: '#005E6E',
    darkBlue: '#102F3F',
    blackPearl: '#002633',
    blackPearl10: '#E5E9EB',
    blackPearl30: '#B2BEC2',
    extraLightGold: '#FFF9E5',
    lightGold: '#FFEFBF',
    gold: '#FFBF00',
    darkGold: '#FF9700',
    extraLightPink: '#FFE5E5',
    lightPink: '#FFBFBF',
    pink: '#BF0040',
    darkPink: '#7F002A',
    extraLightGreen: '#E6FFE6',
    lightGreen: '#BFFFBF',
    green: '#30BF30',
    darkGreen: '#208020',
    emeraldGreen: '#009383',
    white: '#FFF',
    grey25: '#FAFAFA',
    grey50: '#F0F1F2',
    grey100: '#E0E3E5',
    grey200: '#C6CACC',
    grey250: '#b4b4b4',
    grey300: '#ABB0B2',
    grey400: '#919699',
    grey500: '#777C7F',
    grey550: '#777777',
    grey600: '#5F6466',
    grey700: '#464A4C',
    grey800: '#2E3133',
    grey900: '#171819',
    black: '#000',
    borderItem: '#22273A'
  },
  media: {
    tablet: '551px',
    tabletHorizontal: '768px',
    laptop: '993px',
    wideLaptop: '1200px',
    desktop: '1579px'
  },

  sidebar: {
    zIndex: 101
  },
  transition: {
    duration: {
      short: 200
    },
    easing: {
      easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)'
    }
  }
};

export const materialTheme = createTheme({
  palette: {
    brand: {
      extraLightBlue: '#E5F7FF',
      lightBlue: '#ACD2E5',
      whiteBlue: '#E6F7FF',
      midBlue: '#8FAFBF',
      blue: '#335566',
      borderBlue: '#005E6E',
      darkBlue: '#102F3F',
      blackPearl: '#002633',
      blackPearl10: '#E5E9EB',
      blackPearl30: '#B2BEC2',
      extraLightGold: '#FFF9E5',
      lightGold: '#FFEFBF',
      gold: '#FFBF00',
      darkGold: '#FF9700',
      extraLightPink: '#FFE5E5',
      lightPink: '#FFBFBF',
      pink: '#BF0040',
      darkPink: '#7F002A',
      extraLightGreen: '#E6FFE6',
      lightGreen: '#BFFFBF',
      green: '#30BF30',
      darkGreen: '#208020',
      emeraldGreen: '#009383'
    },
    grey: {
      '600': '#5F6466',
      '800': '#2E3133',
      '900': '#171819'
    }
  },
  typography: {
    fontFamily: "'Open Sans', sans-serif"
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#777777',
          letterSpacing: '0.04em',
          lineHeight: '18px',
          fontSize: '12px'
        }
      }
    }
  }
});
